import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { paths, ROOTS } from '@/shared/config/paths';
import { withSuspense } from '../utils';
import type { TypedRouteObject } from '../types';

const User = lazy(() => import('@pages/user'));
const UserList = lazy(() => import('@pages/user/user/UserList'));
const UserDetail = lazy(() => import('@pages/user/user/UserDetail'));

export const userRoutes: TypedRouteObject = {
	path: ROOTS.USER,
	element: withSuspense(User),
	handle: {
		title: '회원 관리',
		subTitle: '락앤런 트레일러닝 회원가입 현황'
	},
	children: [
		{
			index: true,
			element: <Navigate to="list" replace />
		},
		// 회원 목록
		{
			path: paths.user.list.path,
			element: withSuspense(UserList),
			handle: {
				title: '락앤런 트레일러닝 회원 관리',
				subTitle: '회원 전체 목록'
			}
		},
		{
			path: paths.user.detail.path,
			element: withSuspense(UserDetail),
			handle: {
				isGoBack: true,
				title: '락앤런 회원 관리',
				subTitle: '회원 관리 > 개인 회원 전체 목록 > 회원 상세 정보'
			}
		},
	]
}
